import React, { Component } from 'react';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import AdminBookingListPage from '../../../components/AdminBooking/List/AdminBookingList';

class BookingPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
    }

    render() {
        return (
            <MainContainer title="Booking Management" menukey='booking-item'>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: "auto" }}>
                            <AdminBookingListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default BookingPage